// Basic imports
import { createApp } from "vue";
import { createPinia } from "pinia";
import TheApp from "@/App.vue";
import { router } from "@/router/router";

// Plugins
import "@/plugins/dayjs";

// Tooltips
import FloatingVue from "floating-vue";

import "@/scss/properties.scss";
import "@/scss/general/general.scss";

// Element plus
import { ElLoading } from "element-plus";

// 3rd party logins
import vue3GoogleLogin from "vue3-google-login";

// Translations
import { gettext } from "@/services/translation";

// Error tracking
import { addDynamicImportBreadcrumb, captureException, initSentry } from "@/services/analytics/sentry";

// HTML <head> tag
import { createHead } from "@unhead/vue/client";

// Custom directives
import errorShake from "@/directives/errorShake";
import animatePop from "@/directives/animatePop";

// Onload animations (and more)
import { MotionPlugin } from "@vueuse/motion";

const app = createApp(TheApp);
initSentry(app);
app.use(createPinia());
app.use(gettext);
app.use(createHead());
app.use(vue3GoogleLogin, { clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID });
app.use(router);
app.use(FloatingVue);
app.use(MotionPlugin);

app.directive("loading", ElLoading.directive);
app.directive("error-shake", errorShake);
app.directive("animate-pop", animatePop);

app.config.errorHandler = (err, _instance, info) => {
  captureException(err);
  console.error("[Vue]", info, err);
};

window.addEventListener("unhandledrejection", (event) => {
  captureException(event.reason);
});

// Vite wraps every dynamic import() (route views and defineAsyncComponent components alike) through
// its own runtime helper, which dispatches this event on failure. Actual recovery happens locally via
// router.onError (see dynamicImportRecovery.ts) and useAsyncComponent - this is purely a centralized
// observability tap, so it must not call preventDefault(): doing so would swallow the rejection and
// stop those local recovery handlers from ever running.
window.addEventListener("vite:preloadError", (event) => {
  addDynamicImportBreadcrumb((event as Event & { payload: unknown }).payload);
});

app.mount("#app");
